import { render, staticRenderFns } from "./orderDetail.vue?vue&type=template&id=501d525e&scoped=true"
import script from "./orderDetail.vue?vue&type=script&lang=js"
export * from "./orderDetail.vue?vue&type=script&lang=js"
import style0 from "./orderDetail.vue?vue&type=style&index=0&id=501d525e&prod&lang=less"
import style1 from "./orderDetail.vue?vue&type=style&index=1&id=501d525e&prod&lang=less&scoped=true"
import style2 from "./orderDetail.vue?vue&type=style&index=2&id=501d525e&prod&lang=less&scoped=true"
import style3 from "./orderDetail.vue?vue&type=style&index=3&id=501d525e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_2aqslel7prtkk4onzp5d3vudie/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "501d525e",
  null
  
)

export default component.exports